import { TasksListOrderByEnum } from '@/generated/graphql';
import { type SortState } from './types';
import { SuiDataTableSortDirection } from '@developers/scoro-ui';

export const TABLE_COLUMN = {
	Collapsible: 'collapsible',
	Assignee: 'assignee',
	Actions: 'actions',
	Title: 'title',
	Subitems: 'subitems',
	Comments: 'comments',
	Status: 'status',
	ActivityType: 'activity_type',
	Progress: 'task_progress',
	StartDate: 'start_date',
	DueDate: 'due_date',
	Budget: 'budget',
	RemainingBudget: 'remaining_budget',
	Planned: 'planned',
	Done: 'done',
	Remaining: 'remaining',
	MarkDone: 'mark_done',
};

// Columns that can toggled on/off and sorted in the column settings
export const SORTABLE_COLUMNS = [
	TABLE_COLUMN.Subitems,
	TABLE_COLUMN.Comments,
	TABLE_COLUMN.Status,
	TABLE_COLUMN.ActivityType,
	TABLE_COLUMN.Progress,
	TABLE_COLUMN.StartDate,
	TABLE_COLUMN.DueDate,
	TABLE_COLUMN.Planned,
	TABLE_COLUMN.Done,
	TABLE_COLUMN.Remaining,
];

// Maps column IDs to GraphQL OrderBy enums for header click-to-sort
export const COLUMN_HEADER_SORT_MAP = {
	[TABLE_COLUMN.Title]: TasksListOrderByEnum.Name,
	[TABLE_COLUMN.Subitems]: TasksListOrderByEnum.SubtasksCount,
	[TABLE_COLUMN.Comments]: TasksListOrderByEnum.CommentsCount,
	[TABLE_COLUMN.Status]: TasksListOrderByEnum.Status,
	[TABLE_COLUMN.ActivityType]: TasksListOrderByEnum.ActivityType,
	[TABLE_COLUMN.StartDate]: TasksListOrderByEnum.StartDate,
	[TABLE_COLUMN.DueDate]: TasksListOrderByEnum.DueDate,
	[TABLE_COLUMN.Planned]: TasksListOrderByEnum.DurationPlanned,
	[TABLE_COLUMN.Done]: TasksListOrderByEnum.DurationDone,
	[TABLE_COLUMN.Remaining]: TasksListOrderByEnum.DurationRemaining,
};

export const DEFAULT_SORT_STATE: SortState = {
	columnId: TABLE_COLUMN.DueDate,
	direction: SuiDataTableSortDirection.ASC,
};

export const MAX_AVATARS_SHOWN = 3;

export const UNGROUPED_TASKS_ID = 0;

export const COLUMN_TRANSLATION_KEYS: Record<string, string> = {
	[TABLE_COLUMN.Collapsible]: '',
	[TABLE_COLUMN.Assignee]: 'assignee',
	[TABLE_COLUMN.Actions]: '',
	[TABLE_COLUMN.Title]: 'task_title',
	[TABLE_COLUMN.Subitems]: 'subitems',
	[TABLE_COLUMN.Comments]: 'comments',
	[TABLE_COLUMN.Status]: 'status',
	[TABLE_COLUMN.ActivityType]: 'activity',
	[TABLE_COLUMN.Progress]: 'task_progress',
	[TABLE_COLUMN.StartDate]: 'start_date',
	[TABLE_COLUMN.DueDate]: 'tasks_projects_due_date',
	[TABLE_COLUMN.Budget]: 'budget',
	[TABLE_COLUMN.RemainingBudget]: 'remaining_budget',
	[TABLE_COLUMN.Planned]: 'task_progress_estimated',
	[TABLE_COLUMN.Done]: 'task_done',
	[TABLE_COLUMN.Remaining]: 'task_remaining',
	[TABLE_COLUMN.MarkDone]: 'task_done',
};
